/* eslint-disable */
import { GetterTree } from "vuex";
import { Alertcondition } from "@/models/alertcondition";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { AlertconditionState } from "@/types/alertcondition";

const getters: GetterTree<AlertconditionState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Alertcondition();
  },
  find: (state) => (id: number) => {
    return state.pagination
      ? state.pagination.data.find((alertcondition) => {
          return alertcondition.id == id;
        })
      : new Alertcondition();
  },
  selectItem: (state) => {
    return state.pagination
      ? state.pagination.data.map((alertcondition) =>
          Alertcondition.toSelectItem(alertcondition)
        )
      : [];
  },
};

export default getters;
